import {CheckCircleOutlined, SearchOutlined, UndoOutlined} from '@ant-design/icons'
import {Col, Modal, Row, Input, Pagination} from 'antd'
import {ColumnsType, TableProps} from 'antd/lib/table'
import {FC, useState, useEffect} from 'react'
import {useMutation, useQuery} from 'react-query'
import {TableComponent} from '../../../../../../components'
import {useAuth} from '../../../../../modules/auth'
import {approvalDeviceNcc, getlistDeviceNcc} from '../../core/_requests'
import Swal from 'sweetalert2'

interface Props {
  isModalSpeakerOpen: boolean
  handleCancel: () => void
}
const useGetSchedule = (configs: any, state: any) => {
  return useQuery<any, any>(['get_device_ncc', state], () => getlistDeviceNcc(configs, state), {
    keepPreviousData: true,
  })
}
const ThietBiNCCModal: FC<Props> = ({isModalSpeakerOpen, handleCancel}) => {
  const {auth} = useAuth()

  const [localState, setLocalState] = useState<any>({
    currentPage: 1,
    pageSize: 15,
    filter: {
      Imei: undefined,
      Ids: undefined,
    },
  })
  const [imeiInput, setImeiInput] = useState<string>('')
  const [idsInput, setIdsInput] = useState<string>('')

  useEffect(() => {
    if (isModalSpeakerOpen) {
      setImeiInput('')
      setIdsInput('')
      setLocalState({
        currentPage: 1,
        pageSize: 15,
        filter: {
          Imei: undefined,
          Ids: undefined,
        },
      })
    }
  }, [isModalSpeakerOpen])

  const handleSearch = () => {
    const idsArray = idsInput.trim()
      ? idsInput.split(',').map((item) => item.trim()).filter(Boolean)
      : undefined

    setLocalState((prev: any) => ({
      ...prev,
      currentPage: 1,
      filter: {
        Imei: imeiInput.trim() || undefined,
        Ids: idsArray,
      },
    }))
  }

  const handleReset = () => {
    setImeiInput('')
    setIdsInput('')
    setLocalState({
      currentPage: 1,
      pageSize: 15,
      filter: {
        Imei: undefined,
        Ids: undefined,
      },
    })
  }

  const {data: dataSource} = useGetSchedule(auth?.configs, localState)
  const [selectionType] = useState<'checkbox'>('checkbox')
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      key: 'index',
      render: (text, record, index) => index + 1 + (localState.currentPage - 1) * localState.pageSize,
      align: 'center',
      fixed: 'left',
      width: '5%',
    },
    {
      title: 'Tên thiết bị',
      dataIndex: 'Name',
      key: 'Name',
      fixed: 'left',
      width: '200px',
    },
    {
      title: 'IMEI',
      dataIndex: 'Imei',
      key: 'Imei',
      width: 300,
    },
    {
      title: 'Trạng thái phát',
      key: 'State',
      className: 'center white-space',
      align: 'center',
    },

    {
      title: 'ĐỊA BÀN PHÁT',
      dataIndex: 'GroupName',
      key: 'GroupName',
      width: 200,
    },
    {
      title: 'NHIỆT ĐỘ',
      dataIndex: 'TempAir',
      key: 'TempAir',
    },
  ]

  // rowSelection object indicates the need for row selection
  const rowSelection: TableProps<any>['rowSelection'] = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKeys(selectedRowKeys)
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.name === 'Disabled User', // Column configuration not to be checked
      name: record.name,
    }),
  }

  const CheckapprovalItem = useMutation(
    async (selectedRowKeys: any) => {
      return approvalDeviceNcc(auth?.configs, selectedRowKeys)
    },
    {
      onSuccess: (data) => {
        setSelectedRowKeys([])
        Swal.fire({
          title: 'Thành công',
          text: 'Phê duyệt thiết bị thành công',
          icon: 'success',
          confirmButtonText: 'Đồng ý',
        })
      },
      onError: (error) => {
        Swal.fire({
          title: 'Lỗi',
          text: 'Có lỗi trong quá trình phê duyệt thiết bị',
          icon: 'error',
          confirmButtonText: 'Đồng ý',
        })
      },
    }
  )

  const approvalDevice = () => {
    CheckapprovalItem.mutateAsync(selectedRowKeys)
  }

  return (
    <Row gutter={[16, 16]} align='top'>
      <Col span={24}>
        {/* Responsive */}
        <Modal
          title='Danh sách thiết bị chờ phê duyệt'
          centered
          open={isModalSpeakerOpen}
          onCancel={() => {
            setSelectedRowKeys([])
            handleCancel()
          }}
          className='responsive-modal'
          width={1000}
          cancelText='Đóng'
          footer={null}
        >
          <div className='d-flex flex-wrap align-items-center justify-content-between mb-5 gap-3'>
            <div className='d-flex flex-wrap align-items-center gap-3'>
              <div style={{width: '200px'}}>
                <Input
                  placeholder='Tìm theo IMEI'
                  value={imeiInput}
                  onChange={(e) => setImeiInput(e.target.value)}
                  onPressEnter={handleSearch}
                />
              </div>
              {/* <div style={{width: '320px'}}>
                <Input
                  placeholder='Tìm theo danh sách ID (phân cách bằng dấu phẩy)'
                  value={idsInput}
                  onChange={(e) => setIdsInput(e.target.value)}
                  onPressEnter={handleSearch}
                />
              </div> */}
              <button type='button' className='btn btn-primary' onClick={handleSearch}>
                <SearchOutlined /> Tìm kiếm
              </button>
              <button type='button' className='btn btn-light' onClick={handleReset}>
                <UndoOutlined /> Đặt lại
              </button>
            </div>
            <div>
              <button type='button' className='btn btn-primary' onClick={approvalDevice}>
                <CheckCircleOutlined /> Phê duyệt thiết bị
              </button>
            </div>
          </div>
          <TableComponent
            columns={columns}
            dataSource={dataSource?.Data}
            rowSelection={{type: selectionType, ...rowSelection}}
          />
          <Pagination
            locale={{
              items_per_page: '/ trang',
            }}
            className='commentBox mt-6'
            defaultPageSize={localState.pageSize}
            showSizeChanger={true}
            current={localState.currentPage}
            onChange={(page, size) => {
              setLocalState((prev: any) => ({
                ...prev,
                currentPage: page,
                pageSize: size,
              }))
            }}
            total={dataSource?.TotalItems || 0}
            showTotal={(total) => (
              <span>
                Tổng: <strong>{total}</strong> bản ghi
              </span>
            )}
            pageSizeOptions={[10, 20, 50, 100]}
          />
        </Modal>
      </Col>
    </Row>
  )
}

export default ThietBiNCCModal
